import { Box, CircularProgress, Grid, Typography } from '@mui/material'
import { useParams } from 'react-router-dom'
import { Formtitle } from '../../components'
import IperiaNextRegistrationButton from '../../components/iperia/IperiaNextRegistrationButton'
import SignedBiDownloadButton from '../../components/iperia/SignedBiDownloadButton'
import { useIperiaStatus } from '../../hooks/useIperiaStatus'
import { downloadLearnerSignedBi } from '../../utils/iperiaSignedBi'

const Success = () => {
  const { global_id: globalId } = useParams<{ global_id: string }>()
  const { status, loading, error } = useIperiaStatus()

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    )
  }

  if (error || !status) {
    return (
      <Typography color="error" sx={{ p: 2 }}>
        Impossible de charger votre dossier.
      </Typography>
    )
  }

  const waitingForParent = Boolean(status.bi_am_signed_at && !status.bi_pe_signed_at)
  const parentEmail = status.parent_employeur?.parent_email

  return (
    <Grid container direction="column">
      <Formtitle
        title={waitingForParent ? 'Signature du parent employeur en attente' : 'Inscription finalisée'}
        subtitle={
          waitingForParent
            ? `Le bulletin a été envoyé${parentEmail ? ` à ${parentEmail}` : ''}.\nVotre inscription sera finalisée dès sa signature.`
            : 'Le document a été signé par les deux parties.'
        }
      />

      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
        <IperiaNextRegistrationButton />
      </Box>
      {!waitingForParent && globalId && (
        <Box sx={{ mt: 3 }}>
          <SignedBiDownloadButton onDownload={() => downloadLearnerSignedBi(globalId)} />
        </Box>
      )}
    </Grid>
  )
}

export default Success
